module.exports = __webpack_public_path__ + "static/media/Dr. Mahfoodh.d4aab22d.jpg";